import styles from "../styles/Reviews.module.scss";
import person from "../../../assets/images/person.png";
import React from "react";

function Reviews() {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.title}>My Clients Love My Work</div>
      <ReviewCard />
    </div>
  );
}

function ReviewCard() {
  return (
    <div className={styles.reviewcontainer}>
      <UserContainer />
      <ReviewDescription />
    </div>
  );
}

function UserContainer() {
  return (
    <div className={styles.usercontainer}>
      <img alt="userimage" className={styles.userimage} src={person}></img>
      <div className={styles.usernameprofessioncontainer}>
        <div className={styles.username}>Abdulsamad</div>
        <div className={styles.userprofession}>UI UX Designer</div>
      </div>
    </div>
  );
}
function ReviewDescription() {
  return (
    <div className={styles.descriptioncontainer}>
      <div className={styles.reviewdescription}>
        Good things the user said about our services, Good things the user said
        about our services, Good things the user said about our services, Good
        things the user said about our services, Good things the user said about
        our services,
      </div>
    </div>
  );
}
export default Reviews;
